import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "5",
      y: "7",
      width: "20",
      height: "3",
      rx: "1.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("rect", {
      x: "5",
      y: "14",
      width: "20",
      height: "3",
      rx: "1.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("rect", {
      x: "5",
      y: "21",
      width: "20",
      height: "3",
      rx: "1.5",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }